module.exports = "data:text/html;charset=utf-8;base64,PGEgY2xhc3M9ImZhIGZhLWxnIGZhLXF1ZXN0aW9uLWNpcmNsZSB0YXgtZmVlLWljb24iIHRhYmluZGV4PSIwIj48L2E+"